<template>
  <div v-if="formStatus.showForm && formObj.templates">
    <div class="d-flex flex-wrap align-items-center mb-2">
      <span class="fw-medium me-1 mb-1 btn btn-dark">
        {{$t('form_general.templates.title')}}
      </span>
      <div
          v-for="(templatesItem, templatesIndex)  in formObj.templates"
            class="me-2"
      >
        <a
          @click.prevent="prefillTempaltesFormData(templatesIndex)"
          :class="'btn me-1 mb-1' + (templatesItem.is_active? ' btn-danger': ' btn-warning')"
        >
          <i v-if="templatesItem.ico" :class="templatesItem.ico"></i> {{templatesItem.title}}
        </a>
      </div>
    </div>
  </div>

  <div ref="formResultPosition"></div>

  <div
      v-if="formStatus.is_submit && formStatus.is_loading"
       class="fullscreen-message d-flex align-items-center justify-content-center"
  >
    <div class="">
      <div class="text-center">
        <div class="spinner-border text-secondary" role="status">
          <span class="visually-hidden">{{$t('form_general.loading_short_title')}} </span>
        </div>
      </div>
      <span>{{$t('form_general.wait_processing_request_title')}}</span>
    </div>
  </div>

  <div
      v-else-if="formStatus.is_submit && !formStatus.is_loading && formStatus.is_validate"
      class="fullscreen-message d-flex align-items-center justify-content-center"
  >
    <div class="save-wrap">
      <div class="text-center">
        <i class="bi bi-check-circle-fill fs-1 text-success mb-3"></i>
      </div>
      <div class="text-success text-center fs-2">{{$t('form_general.save_successfully_title')}}</div>
      <ul v-if="hook_action" class="mt-2 list-group">
        <li
            v-for="(hookItem)  in hook_action"
             class="list-group-item"
        >
          <strong>{{hookItem.title}}</strong>&nbsp;
          <span v-if="hookItem.status">
          {{hookItem.status}}<i class="bi bi-check"></i>
        </span>
          <span v-else>
            {{$t('form_general.wait_for_running_title')}}  <i class="bi bi-clock-fill"></i>
        </span>
        </li>
      </ul>
      <div
          v-else
        class="mt-3"
      >
        <div
            v-for="(linkItem, linkIndex)  in after_links"
        >
          <router-link
              :to="linkItem.path"
              class="btn-outline-secondary link-secondary text-decoration-none mt-2"
          >
            <i v-if="linkItem.ico" :class="linkItem.ico+ ' me-2'"></i> {{linkItem.title}}
          </router-link>
        </div>
      </div>
      <div v-if="hook_action && hook_status" class=" mt-2">
        <div class="alert alert-success">
          <i class="bi bi-check-circle"></i> <span>{{hook_status}}</span>
        </div>

        <div
            class="mt-3"
        >
          <div
              v-for="(linkItem, linkIndex)  in after_links"
          >
            <router-link
                :to="linkItem.path"
                class="btn-outline-secondary link-secondary text-decoration-none mt-2"
            >
              <i v-if="linkItem.ico" :class="linkItem.ico+ ' me-2'"></i> {{linkItem.title}}
            </router-link>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div
      v-else-if="formStatus.is_submit && !formStatus.is_loading && !formStatus.is_validate"
      class="fullscreen-message invalid d-flex align-items-center justify-content-center"
  >
    <div>
      <div class="text-center">
        <i class="bi bi-exclamation-triangle-fill fs-1 text-danger"></i>
      </div>
      <span class="text-danger text-center fs-2">{{err.message}}</span>
    </div>
  </div>


  <form
      v-if="formStatus.showForm && !formStatus.is_loading"
      @submit.prevent="submitForm"
      class="d-xxl-flex flex-wrap g-2"
      novalidate
  >
    <template
        v-if="formObj.global_lang_switch && Object.keys(formObj.global_lang_switch).length > 1"
    >
      <ul
          class="nav nav-tabs mb-2 lang-selector-wrap w-100"
      >
        <li
            class="nav-item disabled">
          <span class="nav-link disabled">
            {{ $t('form_general.switch_languages') }}
          </span>
        </li>
        <li
            v-for="(langItem, langIndex) in formObj.global_lang_switch"
            class="nav-item"
        >
          <a
              @click.prevent="setActiveLang(langIndex)"
              href="#"
              :class="'nav-link' + ((activeLang == langIndex)? ' active':'')"
          >
            <country-flag
                :country='langItem.flag'
                size="small"
            />
            {{langItem.title}}
          </a>
        </li>
      </ul>
    </template>

    <fieldset
        v-for="(sectionItem, sectionIndex)  in formObj.body"
        :class="'border border-light rounded-4 flex-fill p-2 p-sm-4' + (sectionItem.class? (' '+ sectionItem.class): '') + ' children-count-' + Object.keys(sectionItem.inputs).length"
    >

      <template v-if="sectionItem.display">
        <legend
            v-if="
              Object.keys(formObj.body).length > 1
              && countVisibleInputs(sectionItem)
            "
            class="fs-4 fw-medium badge text-bg-light text-start"
        >
          <i v-if="sectionItem.ico" :class="sectionItem.ico + ' me-1 fs-5'"></i>
         {{sectionItem.title}}
        </legend>
        <div class="fieldset-content-wrap">
          <div
              v-for="(inputItem, inputIndex)  in sectionItem.inputs"
              v-show="inputItem.display"
              :style="inputItem.invalid? ' ': null"
              :class="'mb-2 p-2' + (inputItem.invalid?' border border-danger rounded-3 is-invalid':'')"
              :data-component="inputItem.component_name"
          >
            <strong v-if="inputItem.type!= 'hidden'" class="fs-4 text-secondary fw-lighter">{{inputItem.title}}</strong>&nbsp;<br>


            <template
              v-if="this.$options.components[inputItem.component_name]"
            >
              <component
                  v-bind:is="inputItem.component_name"
                  v-model="formData[inputItem.name]"
                  :inputObj="inputItem"
                  :formObj="formObj.body"
                  :activeLang="activeLang"
              ></component>
            </template>
            <div
                v-else
            >
              <pre>NEEXISTUJE {{ inputItem.component_name }}</pre>
            </div>


            <div
                v-if="inputItem.invalid && inputItem.invalid.message"
                class="ms-2"
            >
              <span class="is-invalid"></span>
              <div
                  v-html="inputItem.invalid.message"
                  class="invalid-feedback"
              >
              </div>
            </div>

            <div v-if="inputItem.hint" class="mt-1">
              <i class="bi bi-info-circle me-1"></i>
              <small class="fs-6" v-html="inputItem.hint"></small>
            </div>

          </div>
        </div>

      </template>

    </fieldset>

    <div
        class="btn-wrap d-flex justify-content-center w-100"
    >
    <div
        v-for="(btntItem, btnIndex)  in formObj.btns"
    >
      <button
          :type="btntItem.type"
          class="btn btn-dark btn-lg"
      >
        {{btntItem.title}}
      </button>
    </div>
  </div>
  </form>

  <display-debug>
    <template #debugView>formData [@form] {{formData}}</template>
  </display-debug>

<!--
  <display-debug>
    <template #debugView>formObj.body {{formObj.body}}</template>
  </display-debug>
-->
</template>

<script>
import CountryFlag from "vue-country-flag-next"
import HiddenInput from "@/components/general/form/inputs/HiddenInput";
import TextInput from "@/components/general/form/inputs/TextInput";
import TextInputLang from "@/components/general/form/inputs/TextInputLang";
import TextareaInput from "@/components/general/form/inputs/TextareaInput";
import TextareaInputLang from "@/components/general/form/inputs/TextareaInputLang";
import SelectInput from "@/components/general/form/inputs/SelectInput";
import SegmentInput from "@/components/general/form/inputs/SegmentInput";
import ImageInput from "@/components/general/form/inputs/ImageInput";
import BooleanInput from "@/components/general/form/inputs/BooleanInput";
import TreeSelectInput from "@/components/general/form/inputs/TreeSelectInput";
import TreeSelectCustomInput from "@/components/general/form/inputs/TreeSelectCustomInput";
import TagsInput from "@/components/general/form/inputs/TagsInput";
import DateTimeInput from "@/components/general/form/inputs/DateTimeInput";
import DateInput from "@/components/general/form/inputs/DateInput";
import CheckboxSimpleInput from "@/components/general/form/inputs/CheckboxSimpleInput";
import CheckboxMultiInput from "@/components/general/form/inputs/CheckboxMultiInput";
import RadioInput from "@/components/general/form/inputs/RadioInput";
import ImageThumb from "@/components/general/form/inputs/ImageThumb";
import GalleryInput from "@/components/general/form/inputs/GalleryInput";
import PasswordInput from "@/components/general/form/inputs/PasswordInput";
import MetaInput from "@/components/general/form/inputs/MetaInput";
import RangeInput from "@/components/general/form/inputs/RangeInput";
import DateRangeInput from "@/components/general/form/inputs/DateRangeInput";
import RestaraceJidloVariantaInput from "@/components/general/form/inputs/restaurace/RestaraceJidloVariantaInput";
import RestauraceSekceJidloInput from "@/components/general/form/inputs/restaurace/RestauraceSekceJidloInput";
import OpeningHoursRegularInput from "@/components/general/form/inputs/restaurace/OpeningHoursRegularInput";
import OpeningHoursByDateInput from "@/components/general/form/inputs/restaurace/OpeningHoursByDateInput";
import OrderInput from "@/components/general/form/inputs/OrderInput";
import AddressInput from "@/components/general/form/inputs/AddressInput";
import PriceInput from "@/components/general/form/inputs/PriceInput";
import StoreInput from "@/components/general/form/inputs/StoreInput";
import ParametersInput from "@/components/general/form/inputs/ParametersInput";
import SmartSelectInput from "@/components/general/form/inputs/SmartSelectInput";
import WikiParts from "@/components/general/form/inputs/WikiParts";
import VersionControlInput from "@/components/general/form/inputs/VersionControlInput";
import VenueInput from "@/components/general/form/inputs/VenueInput.vue";
import GpsInput from "@/components/general/form/inputs/GpsInput.vue";
import InvoiceCompanyInput from "@/components/general/form/inputs/InvoiceCompanyInput.vue";
import InvoiceItemsInput from "@/components/general/form/inputs/InvoiceItemsInput.vue";
import InvoiceItemsInput2 from "@/components/general/form/inputs/InvoiceItemsInput2.vue";
import InvoiceSymbolsInput from "@/components/general/form/inputs/InvoiceSymbolsInput.vue";
import EmailInfoInput from "@/components/general/form/inputs/EmailInfoInput.vue";
import JsonInput from "@/components/general/form/inputs/JsonInput.vue";
//import HistoryInput from "@/components/general/form/inputs/HistoryInput.vue";
import HistoryInput2 from "@/components/general/form/inputs/HistoryInput2.vue";
import HistoryInput3 from "@/components/general/form/inputs/HistoryInput3.vue";
import JsonInput2 from "@/components/general/form/inputs/JsonInput2.vue";
import PriceInput2 from "@/components/general/form/inputs/PriceInput2.vue";
import ParametersInput2 from "@/components/general/form/inputs/ParametersInput2.vue";
import ReservationInput from "@/components/general/form/inputs/ReservationInput.vue";
import JsonDisplay from "@/components/general/form/inputs/JsonDisplay.vue";
import NotificationInput from "@/components/general/form/inputs/NotificationInput.vue";
import MultiImageInput from "@/components/general/form/inputs/MultiImageInput.vue";



import axios from "axios";
import general from "@/components/config/general";

let timer_form_refresh;
let timer_form_refresh_delay = 200;
export default {
  name: "FormGeneral",
  components: {
    CountryFlag,
    axios,
    HiddenInput,
    TextInput,
    TextInputLang,
    TextareaInput,
    TextareaInputLang,
    SelectInput,
    SegmentInput,
    ImageInput,
    BooleanInput,
    TreeSelectInput,
    TagsInput,
    DateTimeInput,
    DateInput,
    CheckboxSimpleInput,
    CheckboxMultiInput,
    RadioInput,
    ImageThumb,
    GalleryInput,
    PasswordInput,
    MetaInput,
    TreeSelectCustomInput,
    RangeInput,
    DateRangeInput,
    RestaraceJidloVariantaInput,
    RestauraceSekceJidloInput,
    OpeningHoursRegularInput,
    OpeningHoursByDateInput,
    OrderInput,
    AddressInput,
    PriceInput,
    StoreInput,
    ParametersInput,
    SmartSelectInput,
    WikiParts,
    VersionControlInput,
    VenueInput,
    GpsInput,
    InvoiceCompanyInput,
    InvoiceItemsInput,
    InvoiceItemsInput2,
    InvoiceSymbolsInput,
    JsonInput,
    //HistoryInput,
    HistoryInput2,
    HistoryInput3,
    JsonInput2,
    PriceInput2,
    ParametersInput2,
    ReservationInput,
    JsonDisplay,
    EmailInfoInput,
    NotificationInput,
    MultiImageInput
  },
  props: {
    formTitle: {
      type: [String],
      required: false,
      default: null,
    },
    formObj: {
      type: [Object],
      required: false,
      default: null,
    },
    originalPath: {
      type: [String],
      required: false,
      default: null,
    },
    returnData: {
      type: [Object, String, Number],
      required: false,
      default: null,
    },
    formPrefill: {
      type: [Object],
      required: false,
      default: null,
    },
  },
  emits:[
    'update:reloadSignal'
  ],
  data() {
    return {
      formData: {},
      err: null,
      hook_status: null,
      hook_action: [],
      after_links: [],
      formStatus: {
        "showForm": true,
        "is_loading": false,
        "is_submit": false,
        "is_validate": false,
        "is_saved": false,
      },
      activeLang: null,
    }
  },
  methods: {
    setActiveLang(code) {
      this.activeLang = code;
    },
    setTemplate(key) {
      //this.prefillTempaltesFormData(key);
    },
    prefillTempaltesFormData(template_key){
      for (const t_key in this.formObj.templates) {
        this.formObj.templates[t_key].is_active = false;
      }
      if(template_key && this.formObj.templates && this.formObj.templates[template_key]) {
        this.formObj.templates[template_key].is_active = true;
        let aTemplate = this.formObj.templates[template_key]
        for (const section_key in this.formObj.body) {
          for (const input_key in this.formObj.body[section_key].inputs) {
            if(typeof aTemplate.inputs[input_key] != 'undefined') {
              //TODO pokud je prazdna hodnota?


              this.formObj.body[section_key].inputs[input_key].from_template = true;
              this.formObj.body[section_key].inputs[input_key].val = aTemplate.inputs[input_key]

              console.log('dev prefillTempaltesFormData ITEM', input_key, this.formObj.body[section_key].inputs[input_key])
            }else{
              //console.log('dev prefillTempaltesFormData V2 none', input_key)
              //this.formObj.body[section_key].inputs[input_key].val = null;
            }
          }
        }
      }
    },
    async submitForm(){

      this.formStatus.is_submit = true;

      let formData = new FormData();
      formData.append('form_data', JSON.stringify(this.formData));
      this.loadingStatus = true;
      const pseudothis = this


      axios.defaults.baseURL = this.getBaseRoot();
      this.formStatus.is_loading = true



      await axios({
        //url: "/class/tags/save-action?id=1701",
        url: this.formObj.path,
        method: "post",
        data:  formData,
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        //console.log("dev save OK", res.data.status)
        this.formStatus.is_submit = true
        if(res.data.status) {
          this.formStatus.is_validate = true;
          this.formStatus.showForm = false;
          this.hook_action = res.data.response.action_hook
          this.after_links = res.data.response.after_links;

          //console.log('dev x after_links', this.after_links)

          //emit to parents
          this.returnData.submit = true;
          this.returnData.save = true;
          this.returnData.id = res.data.response.id;
          this.returnData.values = this.formData;
          this.returnData.data = res.data.response.data_saved;

        }else{

          //console.log('form nevalidni', res.data.response.form_invalid)
          this.formStatus.is_validate = false;
          this.err = res.data.err;
          this.formStatus.showForm = true;
          //this.overwriteFormData();
          this.setInvalidateFormInputs(res.data.response.form_invalid);

          //emit to parents
          this.returnData.submit = true;
          this.returnData.save = false;
          //console.log("dev.formGeneral save SUC returnData", this.returnData)
        }
      }) .catch((err) => {
        // alert("dev submit err")
        //pseudothis.err = err;
        //console.log("dev.formGeneral save catch", err)
        this.$refs.formResultPosition.scrollIntoView({ behavior: 'smooth' });
      })
      .finally((f) => {

        if(this.$refs.formResultPosition) {
          this.$refs.formResultPosition.scrollIntoView({ behavior: 'smooth' });
        }



        pseudothis.formStatus.is_loading = false;
        //console.log("dev save finally")
        pseudothis.runHooks()
      })
    },
    overwriteFormData(){
      //console.log('dev overwriteFormData', this.formData);
      for (const section_key in this.formObj.body) {
        for (const input_key in this.formObj.body[section_key].inputs) {
          console.log('overwriteFormData input',input_key, this.formObj.body[section_key].inputs[input_key]);
        }
      }
    },


    setInvalidateFormInputs(invalidate) {
      for (const section_key in this.formObj.body) {
        for (const input_key in this.formObj.body[section_key].inputs) {
          if(invalidate[input_key]){
            this.formObj.body[section_key].inputs[input_key].invalid = {
              "status": true,
              "message": invalidate[input_key].title
            }
            this.formObj.body[section_key].inputs[input_key].val = invalidate[input_key].val;
          }else{
            delete this.formObj.body[section_key].inputs[input_key].invalid;
          }
        }
      }
    },

    runHooks() {
      if (this.hook_action && this.hook_action.length > 0) {
        //this.hook_status =  'Nezavírejte toto okno dokud nedoběhnou tyto akce. Dáme vám vedět jakmile bude hotovo.'
        this.hook_status = this.$t('content.after_save.before');
        this.runHookItem(0);
      }
    },
    async runHookItem(i) {
      if(this.hook_action[i]) {
        const pseudothis = this
        //this.hook_action[i].status = "spusteno"
        this.hook_action[i].status =this.$t('content.after_save.running')
        await axios({
          url: this.hook_action[i].path,
          method: "get",
          withCredentials: true,
          headers: this.getRequestHeader(),
        }).then((res) => {
          pseudothis.hook_action[i].status = this.$t('content.after_save.running')
        })
        .catch((err)=> {
          pseudothis.hook_action[i].status = this.$t('content.after_save.error')
          console.log('dev content runHookItem', err)
        }).finally(()=> {
          pseudothis.hook_action[i].status = this.$t('content.after_save.done')
          i++;
          pseudothis.runHookItem(i);
        })
      }else{
        //this.hook_status = 'Hotovo. Můžete pokračovat v další práci.' //'Hotovo. Můžete zavřít okno.'
        this.hook_status = this.$t('content.after_save.complete')
      }
    },
    reloadData(){
      this.$emit("update:reloadSignal", String(Math.random()));
    },
    variableForm(){
      if(this.formData.nazev_select == 3) {
        //console.log('dev variableForm', this.formData.nazev_select)
        //this.formObj.inputs.nazev_textara.display = false;
      }else{
        //this.formObj.inputs.nazev_textara.display = true;
      }
    },
    prefillFormData(){
      for (const section_key in this.formObj.body) {
        for (const input_key in this.formObj.body[section_key].inputs) {
          this.formData[input_key] = this.formObj.body[section_key].inputs[input_key].val;
        }
      }
    },
    countVisibleInputs(group){
      const count = Object.keys(group.inputs).length;
      let countInvisible = 0;
      if(group.inputs) {
        for (const input_key in group.inputs) {
          if(group.inputs[input_key].display == false) countInvisible++;
        }
      }

      //console.log('dev countVisibleInputs', count, countInvisible, group.inputs)

      if(count == 0) {
        return false;
      } else if(count == countInvisible) {
        return false
      } else {
        return true;
      }



    }
  },
  watch: {
    formPrefill: {
      handler(newVal, oldVal) {
        for (const section_key in this.formPrefill) {
          for (const input_key in this.formPrefill[section_key].inputs) {
            if (typeof this.formPrefill[section_key].inputs[input_key].value != "undefined"){
              this.formObj.body[section_key].inputs[input_key].val = this.formPrefill[section_key].inputs[input_key].value;
            }
            if (typeof this.formPrefill[section_key].inputs[input_key].readonly != "undefined"){
              this.formObj.body[section_key].inputs[input_key].readonly = this.formPrefill[section_key].inputs[input_key].readonly;
            }
            if (typeof this.formPrefill[section_key].inputs[input_key].required != "undefined"){
              this.formObj.body[section_key].inputs[input_key].required = this.formPrefill[section_key].inputs[input_key].required;
            }

            if (typeof this.formPrefill[section_key].inputs[input_key].templates != "undefined"){
              this.formObj.body[section_key].inputs[input_key].templates = this.formPrefill[section_key].inputs[input_key].templates;
            }
          }
        }
      },
      deep: true,
      immediate: true
    },
    formData: {
      handler(newVal, oldVal) {
        //console.log('dev formGeneral formData', newVal);
        if(this.formObj.action_refresh) {
          //timer_form_refresh_delay
          if(timer_form_refresh) clearInterval(timer_form_refresh);
          timer_form_refresh = setTimeout(
              () => {
               // console.log('dev timer_form_refresh', newVal)
                let formData = new FormData;
                formData.append('form_data', JSON.stringify(newVal))
                axios.defaults.baseURL = this.getBaseRoot();
                axios({
                  url: this.formObj.action_refresh,
                  data: formData,
                  method: 'POST',
                  withCredentials: true,
                  headers: this.getRequestHeader(),
                }).then((res) => {
                  //inputs
                  //console.log('dev refresh on input', this.formObj.action_refresh)

                  for (const group_key in res.data.response.display_changes) {
                    for (const input_key in res.data.response.display_changes[group_key]) {
                      //console.log('dev REFRSH ACTION #2', input_key, res.data.response.display_changes[group_key][input_key] )

                      //input display
                      if(typeof res.data.response.display_changes[group_key][input_key].display != "undefined"){
                        this.formObj.body[group_key].inputs[input_key].display = res.data.response.display_changes[group_key][input_key].display;
                      }
                      //input prefil
                      if(
                          (
                              typeof res.data.response.display_changes[group_key][input_key].is_prefill != "undefined"
                              && res.data.response.display_changes[group_key][input_key].is_prefill
                              //&& typeof this.formObj.body[group_key].inputs[input_key].is_prefill == "undefined"
                          )
                      ){
                        // neni nastaveno
                        if(typeof this.formObj.body[group_key].inputs[input_key].is_prefill == "undefined") {
                          this.formObj.body[group_key].inputs[input_key].is_prefill = true;
                        }
                      }
                      //readonly
                      if(typeof res.data.response.display_changes[group_key][input_key].readonly != "undefined"){
                        console.log('dev form refresh', res.data.response.display_changes[group_key][input_key].readonly)
                        this.formObj.body[group_key].inputs[input_key].readonly = res.data.response.display_changes[group_key][input_key].readonly;
                      }


                      //input
                      if(typeof res.data.response.display_changes[group_key][input_key].params != "undefined"){
                        if(
                            typeof this.formObj.body[group_key].inputs[input_key].params == "undefined"
                         ) {
                          this.formObj.body[group_key].inputs[input_key].params = {
                            create: true
                          };
                        }

                        for(const params_index in res.data.response.display_changes[group_key][input_key].params) {
                          this.formObj.body[group_key].inputs[input_key].params[params_index] = res.data.response.display_changes[group_key][input_key].params[params_index];
                        }
                      }


                      //todo value overwirtp
                      if(typeof res.data.response.display_changes[group_key][input_key].value_overwrite != "undefined"){
                          this.formObj.body[group_key].inputs[input_key].val = res.data.response.display_changes[group_key][input_key].value_overwrite;
                          this.formData[input_key] = res.data.response.display_changes[group_key][input_key].value_overwrite;
                      }


                      //input value
                      if(typeof res.data.response.display_changes[group_key][input_key].value != "undefined"){
                        if(
                            typeof this.formObj.body[group_key].inputs[input_key].val == "undefined"
                            || this.formObj.body[group_key].inputs[input_key].val.length == 0
                            || this.formObj.body[group_key].inputs[input_key].is_prefill == true
                        ) {
                          this.formObj.body[group_key].inputs[input_key].val = res.data.response.display_changes[group_key][input_key].value;
                          this.formData[input_key] = res.data.response.display_changes[group_key][input_key].value;
                        }

                        // this.formObj.body[group_key].inputs[input_key].val = res.data.response.display_changes[group_key][input_key].value;
                        // this.formData[input_key] = res.data.response.display_changes[group_key][input_key].value;
                      }

                      if(typeof res.data.response.display_changes[group_key][input_key].required != "undefined"){
                        this.formObj.body[group_key].inputs[input_key].required = res.data.response.display_changes[group_key][input_key].required;
                      }

                      //error
                      if(typeof res.data.response.display_changes[group_key][input_key].error != "undefined"){
                        //console.log('dev err', group_key, input_key, res.data.response.display_changes[group_key][input_key].error)
                        if(res.data.response.display_changes[group_key][input_key].error) {
                          this.formObj.body[group_key].inputs[input_key].invalid = {
                            status: true,
                            message: res.data.response.display_changes[group_key][input_key].error
                          };
                        }else{
                          this.formObj.body[group_key].inputs[input_key].invalid = {
                            status: false,
                          };
                          delete this.formObj.body[group_key].inputs[input_key].invalid;
                        }
                      }

                      //select-list
                      if(typeof res.data.response.display_changes[group_key][input_key].list != "undefined"){
                        this.formObj.body[group_key].inputs[input_key].templates.data = res.data.response.display_changes[group_key][input_key].list;
                      }

                    }
                  }
                  //sections
                  for (const group_key in res.data.response.section_changes) {
                    if(typeof res.data.response.section_changes[group_key].display != "undefined"){
                      this.formObj.body[group_key].display = res.data.response.section_changes[group_key].display;
                    }
                  }
                })
                .catch((err) => {
                  //this.options = []
                })
              },
              timer_form_refresh_delay
          )
        }
        this.variableForm();
      },
      deep: true,
      immediate: true
    },
  },
  mounted() {



    if(this.formObj.global_lang_switch) {
      for (const i in this.formObj.global_lang_switch){
        if(this.activeLang === null) {
          this.setActiveLang(i);
        }
      }
    }

    if(localStorage.getItem(general.lang_id_local_storage_name)) {
      //console.log('dev form general mounted x', localStorage.getItem(general.lang_id_local_storage_name));
      this.setActiveLang(localStorage.getItem(general.lang_id_local_storage_name));
    }

    this.prefillFormData();
    this.prefillTempaltesFormData(this.$route.query.template);
   // this.animateListLoading()
  }
};
</script>